import {spaceBetween} from "../utilities";

export default {
  computed: {
    deliverabilityScoreTopPadding() {
      const modalMetadata = this.$store.getters.modalMetadataFor('BlacklistModal', this.moduleName)
      if(!modalMetadata || this.activeMessage === false) { return '0px' }

      const space = spaceBetween(modalMetadata.position.bottom, this.$el.querySelector('.delivery-score'))

      if(space > 0) {
        return '0px'
      } else {
        const buffer = 5
        const topPadding = (Math.abs(space) + buffer) + 'px'
        return topPadding
      }
    }
  }
}
